/**
 * Создаёт thunk-действие для отправки socket-события через Redux.
 *
 * Позволяет вызывать socket.emit в компоненте через dispatch с передачей payload:
 *
 * @example
 * // Создаём emitter
 * export const emitBrigadeComposition = createSocketEmitter('brigade_get');
 *
 * // Где-то в компоненте
 * dispatch(emitBrigadeComposition({ brigadeId: 123 }));
 *
 * @example
 * // С токенами авторизации (если сервер требует)
 * export const emitProtectedEvent = createSocketEmitter('secure_event', true);
 * dispatch(emitProtectedEvent({ action: 'sync' }));
 *
 * @param {string} eventName - Название события для socket.emit, например 'brigade_get' или 'btn_transfer_start'.
 * @param {boolean} [withTokens=false] - Если true, к payload добавляются accessToken и refreshToken из localStorage.
 *
 * @returns {(data: Object) => Function} thunk-функция, принимающая payload и отправляющая событие через socket.emit.
 * Она вызывается через dispatch: dispatch(emitter({ ... })).
 */
import { registerReplayable, unregisterReplayable } from './replayableEmits';

export const createSocketEmitter = (eventName, withTokens = false) => {
  return (data = {}) =>
    (dispatch, getState, { socket }) => {
      // Обогащаем payload токенами, если требуется
      const enrichedData = {
        ...data,
        lang: (localStorage.getItem('language') || 'ru').toLowerCase(),
        ...(withTokens && {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken'),
        }),
      };

      // Регистрируем/снимаем только стрим-эмиты для авто-восстановления после реконнекта.
      const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
      registerReplayable(eventName, enrichedData, pathname);
      unregisterReplayable(eventName);

      // Отправляем событие через socket.io
      socket?.emit(eventName, enrichedData);
    };
};
